<template>
  <div>
   <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Faturas </h5>
        <b-button size="sm" :href="`/invoice/add`"
          ><i class="fe fe-plus"></i
        ></b-button>
      </div>
    </div>


    <list-invoice class="mb-4" />
  </div>
</template>
<script>
import moment from "moment";
import ListInvoice from "./lista";


export default {
  components: {
    ListInvoice
    
  },
  data: function() {
    return {
        dateFormat: 'DD/MM/YYYY',
      monthFormat: 'YYYY/MM',
      dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
    };
  },
  methods: {
      moment,
  },
  mounted() {}
};
</script>
